import React from 'react';
import styled from '@emotion/styled';
import EmailIcon from '@material-ui/icons/AlternateEmail';

import { ReactComponent as PhoneIcon } from '@Calix-Commerce/design-system/assets/svg/phone.svg';

import { SUPPORT_EMAIL, SUPPORT_PHONE, SUPPORT_PHONE_CTA } from 'utils/constants';
import userAvatarSrc from 'assets/images/representative.jpg';

const InfoBlockStyled = styled.div`
  padding: 1.07rem;
  display: flex;
`;

const PictureWrapper = styled.div`
  width: 60px;
  height: 60px;
  margin-right: 0.75rem;

  img {
    width: 100%;
    border: 1px solid #808080;
  }
`;

const Title = styled.div`
  margin-bottom: 0.5rem;
  margin-top: 0.2rem;
  font-size: 1.05rem;
`;

const Subtitle = styled.div`
  font-size: 0.9rem;
  margin-bottom: 1.5rem;
  font-style: italic;
  white-space: nowrap;
`;

const InfoItem = styled.div`
  display: flex;
  align-items: center;
  line-height: 1;
  margin-bottom: 0.4rem;

  svg {
    color: ${({ theme }) => theme.colors.primary};
    width: 1.08rem;
    height: 1.08rem;
    margin-right: 0.35rem;
  }

  a {
    text-decoration: none;
    color: ${({ theme }) => theme.colors.textDark};

    &:hover {
      text-decoration: underline;
    }
  }
`;

const InfoBlock = () => {
  return (
    <InfoBlockStyled>
      <PictureWrapper>
        <img src={userAvatarSrc} alt="RMA Support" />
      </PictureWrapper>
      <div>
        <Title>Contact RMA Support</Title>
        <Subtitle>or leave a comment on the relevant RMA Case</Subtitle>
        <InfoItem>
          <EmailIcon />
          <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
        </InfoItem>
        <InfoItem>
          <PhoneIcon />
          <a href={`tel:${SUPPORT_PHONE_CTA}`}>{SUPPORT_PHONE}</a>
        </InfoItem>
      </div>
    </InfoBlockStyled>
  );
};

export { InfoBlock };
